<template>
  <div style="height: 100vh !important;position: relative;">
    <div id="sign-in">
        <!-- mb-3 -->
        <div class="sign-in__card">
            <!-- header menu(login with gmail/shopify or facebook) -->
            <div class="sign-in__card--header">
                <h1 class="sign-in__card--header-title mb-2">Welcome</h1>
            </div>

            <!-- login with email form -->
            <form id="scalify-form" @submit.prevent="loginScalify" class="sign-in__card--body">
                <s-input :id="'scalify-email'" name="email" v-model="email" class="mb-3 sign-in__card--body__input" fieldFor="settings" placeholder="Email"></s-input>
                <div class="sign-in__card--body__password mb-3" >
                    <s-input name="password" class="sign-in__card--body__input password" v-model="password" :type="typeInputPass" fieldFor="settings" placeholder="Password"></s-input>
                    <svg class="sign-in__card--body__password--eye" @click.stop="changeInputPassType" v-if="typeInputPass=='password'" width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 2.77778C9.63199 2.78354 9.2667 2.842 8.91528 2.95139C9.07783 3.23727 9.16438 3.56004 9.16667 3.8889C9.16667 4.14424 9.11637 4.39709 9.01865 4.633C8.92093 4.86892 8.77771 5.08327 8.59715 5.26383C8.41659 5.44439 8.20224 5.58761 7.96632 5.68533C7.73041 5.78305 7.47757 5.83334 7.22222 5.83334C6.89336 5.83106 6.57059 5.74451 6.28471 5.58195C6.05917 6.36418 6.08546 7.19754 6.35985 7.96399C6.63425 8.73044 7.14284 9.39113 7.8136 9.85247C8.48435 10.3138 9.28325 10.5524 10.0971 10.5345C10.911 10.5165 11.6987 10.243 12.3484 9.75256C12.9982 9.26212 13.4772 8.57968 13.7176 7.80188C13.958 7.02409 13.9475 6.19038 13.6877 5.41885C13.428 4.64732 12.932 3.97709 12.2702 3.50308C11.6083 3.02907 10.8141 2.77533 10 2.77778ZM19.8792 6.15973C17.9962 2.48577 14.2684 0 10 0C5.73159 0 2.00276 2.4875 0.120815 6.16008C0.0413845 6.3172 0 6.4908 0 6.66685C0 6.84291 0.0413845 7.0165 0.120815 7.17362C2.0038 10.8476 5.73159 13.3334 10 13.3334C14.2684 13.3334 17.9972 10.8459 19.8792 7.17328C19.9586 7.01616 20 6.84256 20 6.66651C20 6.49045 19.9586 6.31685 19.8792 6.15973ZM10 11.6667C6.57465 11.6667 3.43436 9.75696 1.73853 6.66668C3.43436 3.5764 6.5743 1.66667 10 1.66667C13.4257 1.66667 16.5656 3.5764 18.2615 6.66668C16.566 9.75696 13.4257 11.6667 10 11.6667Z" fill="#2B4D75"/>
                    </svg>
                    <svg class="sign-in__card--body__password--eye big" @click.stop="changeInputPassType" v-else width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.8122 14.7183L1.12527 0.109684C1.07402 0.0686475 1.01518 0.0381079 0.952123 0.0198092C0.889065 0.00151057 0.823021 -0.00418879 0.75776 0.00303655C0.6925 0.0102619 0.629302 0.0302704 0.571775 0.0619198C0.514247 0.0935691 0.463517 0.136239 0.42248 0.187494L0.10999 0.577795C0.0688564 0.629068 0.0382372 0.687948 0.0198841 0.751067C0.00153093 0.814185 -0.00419592 0.880304 0.0030312 0.945638C0.0102583 1.01097 0.0302976 1.07424 0.0620023 1.13182C0.093707 1.1894 0.136455 1.24017 0.1878 1.28121L18.8747 15.8898C18.926 15.9309 18.9848 15.9614 19.0479 15.9797C19.1109 15.998 19.177 16.0037 19.2422 15.9965C19.3075 15.9893 19.3707 15.9692 19.4282 15.9376C19.4858 15.9059 19.5365 15.8633 19.5775 15.812L19.89 15.4217C19.9311 15.3704 19.9618 15.3116 19.9801 15.2484C19.9985 15.1853 20.0042 15.1192 19.997 15.0539C19.9897 14.9885 19.9697 14.9253 19.938 14.8677C19.9063 14.8101 19.8635 14.7593 19.8122 14.7183ZM9.27471 4.57705L13.4868 7.87007C13.4174 5.997 11.8899 4.49986 10 4.49986C9.75621 4.50032 9.51313 4.52619 9.27471 4.57705ZM10.7253 11.4228L6.51323 8.12975C6.58292 10.0025 8.11037 11.4996 10 11.4996C10.2438 11.4991 10.4868 11.4734 10.7253 11.4228ZM10 3.49989C13.0827 3.49989 15.9089 5.21859 17.4351 7.99976C17.061 8.68423 16.5987 9.31668 16.0601 9.88095L17.2395 10.8028C17.8961 10.1004 18.4524 9.31052 18.8925 8.45568C18.964 8.31427 19.0013 8.15805 19.0013 7.9996C19.0013 7.84115 18.964 7.68492 18.8925 7.54352C17.1963 4.23706 13.8414 1.99994 10 1.99994C8.85316 1.99994 7.75913 2.21868 6.73041 2.58773L8.18068 3.72176C8.77254 3.58739 9.37877 3.49989 10 3.49989ZM10 12.4996C6.91728 12.4996 4.09143 10.7809 2.56491 7.99976C2.93952 7.31529 3.40231 6.68294 3.94144 6.11888L2.7621 5.19703C2.1056 5.89934 1.54941 6.6891 1.10933 7.54383C1.03785 7.68524 1.0006 7.84147 1.0006 7.99991C1.0006 8.15836 1.03785 8.31459 1.10933 8.45599C2.80397 11.7625 6.15887 13.9996 10 13.9996C11.1468 13.9996 12.2409 13.7793 13.2696 13.4118L11.8193 12.2781C11.2275 12.4121 10.6215 12.4996 10 12.4996Z" fill="#2B4D75"/>
                    </svg>
                </div>
                <button id="goToPass" type="submit" class="btn btn--success btn--lg sign-in__card--body__login-button w-100" v-if="!loading">Sign In</button>
                <button class="btn btn--success btn--lg sign-in__card--body__login-button w-100 disabled" v-if="loading">
                    <s-loader :isWhite="true"></s-loader>
                </button>

                <div class="sign-in__card--body__alert text-capitalize mt-2" v-if="messageErreur.length">{{messageErreur.replace(/_/g," ")}}</div>
            </form>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sign-in',
  props:{

  },
  components: {
  },
  watch:{
  },
  data(){
    return{
        loading:false,
        messageErreur:'',
        email: '',
        password: '',
        loadingSignIn:null,
        isScalifyLogin:false,
        typeInputPass:'password',
        isLogged:false,

    };
  },

  mounted(){

  },

  methods:{
    changeInputPassType(){
        if(this.typeInputPass=='password'){
            this.typeInputPass = "text"
        }
        else{
            this.typeInputPass = 'password'
        }
    },
    // access to account
    async loginScalify(){
        this.loading=true;
        try{
            const resultLogin = await this.login(this.email,this.password);

            if (resultLogin && resultLogin.access_token) {
                this.setToken(resultLogin.access_token);
                this.$store.state.user = resultLogin.user;
                this.$router.push('/');
            }else{
                this.messageErreur = "Something went wrong, Please try again later"
                this.loading=false;
            }
            this.loading = false;
        }
        catch(err){
            this.loading = false
        }

        this.loading=false

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
